import React, { Component } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
import ReCAPTCHA from 'react-google-recaptcha';

  export default class AadharAuthentication extends Component {
    constructor(props) {
      super(props);
      this.recaptchaRef = React.createRef();
      this.state = {
        message: sessionStorage.getItem("message"),
        requestId: sessionStorage.getItem("requestId"),
        otp: ["", "", "", "", "", ""],
        mobile: "",
        showOtp: false,
        shownext: false,
        resendTimer: 60, // 1 minutes
        resendEnabled: false,
        resendIntervalId: null,
        captchaToken: null,
        
      };
    }
    
    
    handleCaptchaChange = (value) => {
      this.setState({
        captchaToken: value,
      });
    };
    formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${String(minutes).padStart(2, "0")}:${String(
        remainingSeconds
      ).padStart(2, "0")}`;
    };

    componentDidMount() {
      if (!sessionStorage.getItem("resendOtpCount")) {
        sessionStorage.setItem("resendOtpCount", "0");
      }
      this.startResendCountdown();
    }
    startResendCountdown = () => {
      this.setState({
        resendEnabled: false,
        resendOtpCount: parseInt(sessionStorage.getItem("resendOtpCount")) || 0,
        resendTimer: 60,
      }); // Start with 5 minutes
      const intervalId = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.resendTimer <= 1) {
            clearInterval(this.state.resendIntervalId);
            return { resendEnabled: true, resendTimer: 0 }; // Re-enable button after timer ends
          }
          return { resendTimer: prevState.resendTimer - 1 };
        });
      }, 1000);
      this.setState({ resendIntervalId: intervalId });
    };

    showToast = (msg, type) => {
      switch (type) {
        case "success":
          toast.success(msg);
          break;
        case "error":
          toast.error(msg);
          break;
        case "warning":
          toast.warn(msg); // 'warn' is used instead of 'warning'
          break;
        default:
          toast.success(msg);
      }
    };
    toggleOtpVisibility = () => {
      this.setState((prevState) => ({ showOtp: !prevState.showOtp }));
    };
    handleOtpChange = (e, index) => {
      const val = e.target.value;
      if (/^\d?$/.test(val)) {
        // allow only single digit or empty
        this.setState(
          (prevState) => {
            const newOtp = [...prevState.otp];
            newOtp[index] = val;
            return { otp: newOtp };
          },
          () => {
            // auto focus next input if a digit was entered
            if (val && index < 5) {
              this[`otpInput${index + 1}`].focus();
            }
          }
        );
      }
    };
    handleSubmitBack = () => {
      sessionStorage.setItem("resendOtpCount", "0");
      window.location.href = "/consentcollectionaadhaar";
    };
    resetCaptcha = () => {
      this.setState({ captchaToken: "" });
      if (this.recaptchaRef && this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
      }
    };
    
    handleOtpVerification = (e) => {
      e.preventDefault();
      const { mobile, captchaToken } = this.state;
      const otp = this.state.otp.join("");
    
      if (mobile.trim() === "") {
        this.showToast("Mobile number is required.", "error");
        return;
      }
    
      const mobileRegex = /^\d{10}$/;
      if (!mobileRegex.test(mobile)) {
        this.showToast("Mobile Number must be 10 digits.", "error");
        return;
      }
    
      if (!captchaToken) {
         this.showToast("Please verify that you are not a robot!","error");
        return;
      }
     sessionStorage.setItem("mobile", mobile);
      const formData = new FormData();
      formData.append("captchaToken", captchaToken);
      formData.append("mobile", mobile);
      formData.append("otp", otp);
      formData.append("requestId", this.state.requestId);
    
      fetch(configData.api_url + "C_Abhadetails/submitAadharOtp", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("API Response:", data);
          this.showToast(data.message, data.status);
          if (this.recaptchaRef && this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
          }
          if (data.status === "success") {
            this.setState({ resendOtpCount: "" });
            sessionStorage.setItem("resendOtpCount", "0");
            setTimeout(() => {
              if (data.verifyMobile === false) {
                 window.location.href = "/existingabha";
              } else  {
                window.location.href = "/mobileotp";
              } 
            }, 5000); // 5 seconds delay
           this.showToast("Processing... Redirecting in 5 seconds", "info");
          } 
        })
        
    };
    
    onKeyDown = (e) => {
      if (e.key === " ") {
        e.preventDefault();
        toast.error("Spaces are not allowed.");
      }
    };
    handlemobileChange = (e) => {
      e.preventDefault();
      const fieldValue = e.target.value;
      this.setState({ mobile: fieldValue });
    };
   
    ResendOTP = (e) => {
      e.preventDefault();
      let resendCount = parseInt(sessionStorage.getItem("resendOtpCount")) || 0;
      if (resendCount >= 2) {
        this.showToast("Maximum resend attempts reached.", "error");
        return;
      }
      const formData = new FormData();
      formData.append("requestId", this.state.requestId);

      fetch(configData.api_url + "C_Abhadetails/resendAadharOtp", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            sessionStorage.setItem("resendOtpCount", resendCount + 1);
            clearInterval(this.state.resendIntervalId);
            this.startResendCountdown();
          }
        });
    };
    handleOtpKeyDown = (e, index) => {
      if (e.key === "Backspace" && !this.state.otp[index] && index > 0) {
        this[`otpInput${index - 1}`].focus();
      }
    };

    render() {
      const { showOtp, resendEnabled, resendTimer, otp, mobile, message } =
        this.state;
      return (
        <div>
          {/* <div className="row mb-2" id="flowStyle">
            <div className="col-md-3 flowTab Inactive">
              <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
                <p className="nav-label mt-2">Consent Collection</p>
              </div>
            </div>

            <div className="col-md-3 flowTab active-page">
              <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
                <p className="nav-label mt-2">Aadhaar Authentication</p>
              </div>
            </div>
            <div className="col-md-3 flowTab Inactive">
              <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
                <p className="nav-label mt-2">Communication Details</p>
              </div>
            </div>
            <div className="col-md-3 flowTab Inactive">
              <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
                <p className="nav-label mt-2">ABHA Address Creation</p>
              </div>
            </div>
          </div> */}

          <div className="row justify-content-md-center text-center aadhaarAuthentication">
            <div className="col-md-6 mt-4">
              <Row>
                <div className="col">
                              <div className="widget_BG widget_BG_grid mb-2">
                <Form>
                  <Form.Group>
                    <div
                      className="d-flex gap-2 mb-2"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Form.Label>
                        <b>Confirm OTP</b>
                      </Form.Label>
                      <i style={{ color: "blue" }}>{message}</i>
                    </div>
                    <div
                      className="d-flex gap-2 aadhaarAuthenticationOTP"
                      style={{ justifyContent: "center" }}
                    >
                      {otp.map((digit, index) => (
                        <Form.Control
                          key={index}
                          type={this.state.showOtp ? "text" : "password"}
                          maxLength="1"
                          value={digit}
                          onChange={(e) => this.handleOtpChange(e, index)}
                          onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                          ref={(input) => (this[`otpInput${index}`] = input)}
                          style={{
                            textAlign: "center",
                          }}
                        />
                      ))}
                      <Button
                        variant="outline-secondary"
                        className={`rounded-0 bi ${
                          showOtp ? "bi-eye-slash" : "bi-eye"
                        }`}
                        onClick={() => this.setState({ showOtp: !showOtp })}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group>
                    <Form.Label><b>Mobile Number/ Alter Mobile Number</b></Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile"
                      value={mobile}
                      className="form-control"
                      maxLength={10}
                      onKeyDown={this.onKeyDown}
                      onChange={this.handlemobileChange}
                    />
                    <p>
                      It is preferable to use Aadhaar-linked mobile number. If you
                      choose to use a different mobile number, It will need to be
                      validated again and will be used for all communication
                      related to ABHA.
                    </p>
                  </Form.Group>
                </Form>
                {/* <div as={Row}> */}

              </div>
                </div>
              </Row>
              <Row>
           <div className="col mb-4">
          {parseInt(sessionStorage.getItem("resendOtpCount")) >= 2 ? (
            <div style={{ color: "red", fontWeight: "bold" }}>
              You have used 2 out of 2 resend attempts.
              <br />
              Try after some time if OTP is not received.
            </div>
          ) : (
            <>
              <Button
                className="rounded-0 m-1"
                variant="warning"
                onClick={this.ResendOTP}
                disabled={!resendEnabled}
              >
                Resend OTP { !resendEnabled && 
                `in ${this.formatTime(resendTimer)}` }
              </Button>
              <div style={{ fontSize: "12px", color: "gray" }}>
               Resend OTP Send Only 2 Times in a Session You have used &nbsp;
                {sessionStorage.getItem("resendOtpCount")||0} out of 2.
              </div>
            </>
          )}
        </div>

                    
                  <div className="d-flex align-items-center" >
                  <ReCAPTCHA
                   className="mt-4"
                  sitekey= {configData.captchaKey}
                  ref={this.recaptchaRef} 
                  onChange={this.handleCaptchaChange}
                />
                <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue mt-0" 
                        onClick={() => this.recaptchaRef.current.reset()}/>
                  </div>
              </Row> 
              

            </div>
          </div>
          <div className="row d-flex widget_BG widget_BG_grid m-0">
            <div className="col text-start">
              <Button variant="warning"   className="rounded-0 m-1" onClick={this.handleSubmitBack}>
                Back
              </Button>
            </div>
            <div className="col text-end">
          
              <Button
                className="rounded-0 m-1"
                onClick={this.handleOtpVerification}
              >
                Verify OTP
              </Button>
            </div>
          </div>
        </div>
      );
    }
  }
